import styled from 'styled-components';
import { colors } from 'styles/colors';
import { typography } from 'styles/typography';

export const UserHeaderContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-bottom: 2.5rem;
`;

export const WelcomeSection = styled.div`
  ${typography.heading[3]};
  margin: 0.5rem 0 0.425rem 0;
  color: ${colors.gray[900]};
  color: ${({ theme }) => theme.textHeaderInProfile};
`;

export const TagSection = styled.div`
  ${typography.heading[6]}
  display: flex;
  list-style-type: none;
  align-items: center;
`;

export const Element = styled.div`
  color: ${colors.gray[600]};
  padding: 0 0;
`;

export const Dot = styled.div`
  width: 0.3rem;
  height: 0.3rem;
  border-radius: 50%;
  background: ${colors.gray[600]};
  margin: 0 0.5em;
`;
